<!-- Internal-only dev tool, no translation needed (see command-palette-dev-commands.ts). -->
<dialog
  class="dev-notes"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragBoundary=".cdk-overlay-container"
  open
  aria-labelledby="dev-notes-title"
>
  <header class="dev-notes__header" cdkDragHandle>
    <mat-icon class="dev-notes__grip" aria-hidden="true">drag_indicator</mat-icon>
    <h2 id="dev-notes-title" class="dev-notes__title">Notes</h2>
    <span class="dev-notes__badge">DEV</span>
    <button mat-icon-button type="button" class="dev-notes__close" aria-label="Close notes" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <label for="dev-notes-textarea" class="dev-notes__visually-hidden">Notes</label>
  <textarea
    #textarea
    id="dev-notes-textarea"
    class="dev-notes__textarea"
    rows="8"
    placeholder="Jot something down…"
    [ngModel]="notes.text()"
    (ngModelChange)="notes.setText($event)"
  ></textarea>

  <footer class="dev-notes__hint">Auto-saved locally on this device · Ctrl+Alt+N to toggle · drag the title bar to move</footer>
</dialog>
